import { formActivityAPI } from "../actions/activity";

/**
 * Registra uma atividade de formulário diretamente no serviço de activities
 * (independente da API monolítica). O serviço apenas persiste a atividade.
 * A emissão dos eventos Kafka (contexts / form-config-events) é
 * responsabilidade do back-end (sendEventFormConfigChangeToKafka).
 *
 * @param {Object} params
 * @param {string|null} [params.form]     Nome do formulário (null para categorias)
 * @param {'form'|'field'|'category'} params.entity
 * @param {'created'|'updated'|'deleted'|'sorted'|'archived'} params.action
 * @param {Object|Array|null} [params.payload]
 * @param {string} params.createdBy
 * @param {Object} [params.metadata]              { formId, categoryId, companyId, unitId, userUuid }
 * @param {Object|null} [params.serviceUpdateField] payload de rename de campo
 * @param {Object|null} [params.serviceUpdate]      payload de delete/archive de campo
 * @param {string} [params.createdAt]             ISO8601 (default: agora)
 */
export const trackFormActivity = async ({
  form = null,
  entity,
  action,
  payload = null,
  createdBy,
  metadata,
  serviceUpdateField,
  serviceUpdate,
  createdAt = new Date().toISOString(),
}) => {
  const body = {
    form,
    entity,
    action,
    payload,
    createdBy,
    createdAt,
  };

  if (metadata) body.metadata = metadata;
  if (serviceUpdateField) body.serviceUpdateField = serviceUpdateField;
  if (serviceUpdate) body.serviceUpdate = serviceUpdate;

  try {
    await formActivityAPI.send(body);
  } catch (err) {
    // Não bloqueia a operação principal caso o log falhe.
    console.error("trackFormActivity failed", err);
  }
};
